import React from 'react';
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { labelTipoCliente } from '../../../config/tipoClienteOptions';
import Info360Contenido from './Info360Contenido';

interface Props {
  open: boolean;
  nroCliente: number | null;
  onClose: () => void;
}

/** Info 360 en modal: se usa sobre un pedido/factura en curso para no perder las líneas cargadas. */
const ClienteInfo360Dialog: React.FC<Props> = ({ open, nroCliente, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open && !!nroCliente}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      fullScreen={fullScreen}
      aria-labelledby="info360-dialog-title"
    >
      <DialogTitle id="info360-dialog-title" sx={{ pr: 6 }}>
        <Typography variant="h6" component="span" sx={{ fontWeight: 600, color: '#1976d2' }}>
          Info 360
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="Cerrar"
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {nroCliente ? (
          <Info360Contenido
            nroCliente={nroCliente}
            abrirDocumentosEnNuevaPestana
            accionSecundariaError={{ label: 'Cerrar', onClick: onClose }}
            renderHeader={(cliente) => (
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {(cliente.razonSocial || cliente.nombre || '').trim() || `Cliente #${cliente.nroCliente}`}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  #{cliente.nroCliente}
                  {cliente.cuit ? ` · CUIT ${cliente.cuit}` : ''}
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
                  <Chip
                    size="small"
                    label={labelTipoCliente(cliente.tipoCliente)}
                    color={cliente.tipoCliente?.toUpperCase() === 'I' ? 'default' : 'success'}
                    variant="outlined"
                  />
                  {cliente.condVta ? (
                    <Chip size="small" label={`Cond. venta: ${cliente.condVta}`} variant="outlined" />
                  ) : null}
                  {cliente.listaPrecio?.descripcion || cliente.nroLista ? (
                    <Chip
                      size="small"
                      label={`Lista: ${cliente.listaPrecio?.descripcion || cliente.nroLista}`}
                      variant="outlined"
                    />
                  ) : null}
                </Stack>
              </Box>
            )}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default ClienteInfo360Dialog;
